import { type QueryClient, useQuery } from '@tanstack/react-query';
import { type QueryOptions } from 'typescript/types/QueryOptions';

import { getData as getImageLibrary } from 'api/requests/GET_IMAGE_LIBRARY';

import { getQueryKey } from 'helpers/getQueryKey';

const queryKey = (id: string) => {
  return getQueryKey('IMAGE_LIBRARY', id);
};

const queryFn = (id: string) => {
  return () => {
    return getImageLibrary(id);
  };
};

export type ImageLibrary = Awaited<ReturnType<typeof getImageLibrary>>;

export const preloadImageLibrary = (queryClient: QueryClient, id: string) => {
  return queryClient.fetchQuery({ queryFn: queryFn(id), queryKey: queryKey(id) });
};

export const useQueryImageLibrary = (id: string, options: QueryOptions<ImageLibrary>) => {
  return useQuery({
    queryKey: queryKey(id),
    queryFn: queryFn(id),
    ...options,
  });
};
